// eslint-disable-next-line no-unused-vars
import ClientPayClassClassificationViewModel from '@/models/client/clientPayClassClassificationViewModel'

import { ModelApiService } from './BaseApiService'

export default class ClientApiService extends ModelApiService {
  constructor() {
    super('Client')
  }

  async getGroup(ids) {
    var payload = { Ids: ids, Type: 'GROUP' }
    return await this.post(`search/heirachy`, payload)
  }

  async getClient(ids) {
    var payload = { Ids: ids, Type: 'CLIENT' }
    return await this.post(`search/heirachy`, payload)
  }

  async getLocation(ids) {
    var payload = { Ids: ids, Type: 'LOCATION' }
    return await this.post(`search/heirachy`, payload)
  }

  /**
   * Retrieves a list of sub bubble agreements for a client
   * @returns {Promise<SubBubbleAgreementViewModel[]>}
   */
  async getSubBubbleAgreements(clientId) {
    return await this.get(`${clientId}/sub-bubble-agreements`)
  }

  /**
   * Retrieves a list of pay class classifications for Client
   * @returns {Promise<ClientPayClassClassificationViewModel[]>}
   */
  async getPayClassClassifications(clientId) {
    return await this.get(`${clientId}/pay-class-classifications`)
  }

  /**
   * Retrieves a work schedule for a location
   * @returns {Promise<WorkSchedule>}
   */
  async getWorkSchedule({ clientId, locationId }) {
    return await this.get(`${clientId}/location/${locationId}/work-schedule`)
  }

  /**
   * Updates a work schedule for a location
   * @returns {204 No Content}
   */
  async updateWorkSchedule(payload) {
    return await this.post(`work-schedule`, payload)
  }

  /**
   * Adds or edits a work schedule exception for a location
   * @returns {204 No Content}
   */
  async upsertException({ clientId, locationId, exception }) {
    return await this.post(
      `${clientId}/location/${locationId}/schedule-exception`,
      exception
    )
  }

  /**
   * Deletes a work schedule exception for a location
   * @returns {204 No Content}
   */
  async deleteException({ clientId, locationId, exceptionId }) {
    return await this.delete(
      `${clientId}/location/${locationId}/schedule-exception/${exceptionId}`
    )
  }

  async getBullhornData(clientId) {
    return await this.get(`${clientId}/bullhorn`)
  }
}
